module.exports = __webpack_public_path__ + "img/adetec.dd3f6d5b.jpg";